import * as r from "react";
import a from "../lib/IconBase.es.js";
import i from "../defs/ArrowsOutLineVertical.es.js";
const e = r.forwardRef((o, t) => /* @__PURE__ */ r.createElement(a, { ref: t, ...o, weights: i }));
e.displayName = "ArrowsOutLineVerticalIcon";
const n = e;
export {
  n as ArrowsOutLineVertical,
  e as ArrowsOutLineVerticalIcon
};
